import React, { useState } from "react";
import { Container, Row, Col, Alert, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useBaseUrl } from "../../../context/AppContext";
import "../../../assets/css/customer/customerauth/CustomerLogin.css";

const CustomerRegister = () => {
  const navigate = useNavigate();
  const { baseUrl } = useBaseUrl();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] =
    useState(false);
  const [registerError, setRegisterError] =
    useState("");
  // ================= REGISTER =================
  const handleRegister = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formdata = new FormData();
    formdata.append(
      "fullname",
      fullName
    );
    formdata.append(
      "email",
      email
    );
    formdata.append(
      "password",
      password
    );
    axios.post(`${baseUrl}/customer/auth/customer-register`,formdata
      )
      .then((response) => {
        console.log(
          "REGISTER RESPONSE:",
          response.data
        );

       if (response.data.customer) {
  const customer = response.data.customer;

  localStorage.setItem(
    "customerData",
    JSON.stringify(customer)
  );

  localStorage.setItem(
    "customerEmail",
    customer.email
  );

  localStorage.setItem(
    "customerPassword",
    password
  );

  localStorage.setItem(
    "customerId",
    customer.id
  );

  navigate("/customer/dashboard");
} else {
  setRegisterError("Registration failed");
}
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setRegisterError(
          "Something went wrong!"
        );
        setIsLoading(false);
      });
  };
  return (
    <div className="sgc-login-page">
      <Container fluid className="p-0">
        <Row className="justify-content-center m-0">
          <Col xs={12} className="p-0">
            <div className="sgc-login-card mx-auto">
              <h1 className="sgc-login-heading">
                Customer Register
              </h1>
              {registerError && (
                <Alert variant="danger">
                  {registerError}
                </Alert>
              )}
              <div>
                <div className="sgc-login-form-group">
                  <label>
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="sgc-login-input"
                    value={fullName}
                    onChange={(e) =>
                      setFullName(e.target.value)
                    }
                  />
                </div>
                <div className="sgc-login-form-group">
                  <label>
                    Email
                  </label>
                  <input
                    type="email"
                    className="sgc-login-input"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                  />
                </div>
                <div className="sgc-login-form-group">
                  <label>
                    Password
                  </label>
                  <input
                    type="password"
                    className="sgc-login-input"
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                  />
                </div>
                <button
                  type="button"
                  className="sgc-login-btn-primary"
                  disabled={isLoading}
                  onClick={handleRegister}
                >
                  {isLoading ? (
                    <Spinner
                      animation="border"
                      size="sm"
                    />
                  ) : (
                    "Create Account"
                  )}

                </button>

              </div>

            </div>

          </Col>

        </Row>

      </Container>

    </div>

  );

};

export default CustomerRegister;